var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f47735;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1265 -71)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1265 71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1265 78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1265 85)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.3895c3b7c9e716606404b64fbc61b728.svg";
export { ForwardRef as ReactComponent };